import { Injectable, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ConfirmationService, MessageService } from 'primeng/api';

import { ManFileService } from './management-file/man-file.service';
import { ManFile } from '../../shared/dto/file/manFile';
import { ExportDataService } from './export-data/export-data.service';
import { TitleService } from './title/title.service';
import { AccountService } from './account/account.service';
import { ParameterService } from './parameter/parameter.service';
import { Title } from '../../shared/dto/title/title';
import { TlkService } from './tlk/tlk.service';
import { DashboardService } from './dashboard/dashboard.service';

@Injectable({
	providedIn: 'root',
})
export class FacadeSacimService {
	private _ConfirmationService: ConfirmationService;
	private _MessageService: MessageService;
	private _TranslateService: TranslateService;
	private _ManFileService: ManFileService;
	private _ExportDataService: ExportDataService;
	private _TitleService: TitleService;
	private _AccountService: AccountService;
	private _ParameterService: ParameterService;
	private _TlkService: TlkService
	private _DashboardService: DashboardService

	public get confirmationService(): ConfirmationService {
		if (!this._ConfirmationService) {
			this._ConfirmationService = this.injector.get(ConfirmationService);
		}

		return this._ConfirmationService;
	}

	public get messageService(): MessageService {
		if (!this._MessageService) {
			this._MessageService = this.injector.get(MessageService);
		}

		return this._MessageService;
	}

	public get translateService(): TranslateService {
		if (!this._TranslateService) {
			this._TranslateService = this.injector.get(TranslateService);
		}

		return this._TranslateService;
	}

	public get manFileService(): ManFileService {
		if (!this._ManFileService) {
			this._ManFileService = this.injector.get(ManFileService);
		}
		return this._ManFileService;
	}

	public get exportDataService(): ExportDataService {
		if (!this._ExportDataService) {
			this._ExportDataService = this.injector.get(ExportDataService);
		}

		return this._ExportDataService;
	}

	public get titleService(): TitleService {
		if (!this._TitleService) {
			this._TitleService = this.injector.get(TitleService);
		}

		return this._TitleService;
	}

	public get accountService(): AccountService {
		if (!this._AccountService) {
			this._AccountService = this.injector.get(AccountService);
		}
		return this._AccountService;
	}

	public get parameterService(): ParameterService {
		if (!this._ParameterService) {
			this._ParameterService = this.injector.get(ParameterService);
		}
		return this._ParameterService;
	}

	public get tlkService(): TlkService {
		if (!this._TitleService) {
			this._TlkService = this.injector.get(TlkService);
		}

		return this._TlkService;
	}	

	public get dashboardService(): DashboardService {
		if (!this._DashboardService) {
			this._DashboardService = this.injector.get(DashboardService);
		}
		return this._DashboardService;
	}

	constructor(private injector: Injector) {}

	/**************************************Library Core *****************************************************/
	showDialogConfirm(header: string, message: string): boolean {
		let response: boolean;

		this.confirmationService.confirm({
			message: message,
			header: header,
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				response = true;
			},
			reject: () => {
				response = false;
			},
		});
		return response;
	}

	showMessage(severity: string, summary: string, message: string) {
		this.messageService.add({
			severity: severity,
			summary: summary,
			detail: message,
		});
	}

	translate(message: string) {
		return this.translateService.instant(message);
	}

	/**************************************Management File *****************************************************/

	getAllFile(country: string, active: boolean) {
		return this.manFileService.getAllFile(country, active);
	}

	getAllMoveFile(
		country: string,
		active: boolean,
		typeTransmission: string,
		typeFile: string,
		startDate: Date,
		endDate: Date
	) {
		return this.manFileService.getAllMoveFile(
			country,
			active,
			typeTransmission,
			typeFile,
			startDate,
			endDate
		);
	}

	processFile(id: number) {
		return this.manFileService.processFile(id);
	}

	putFile(id: number) {
		return this.manFileService.putFile(id);
	}

	DownloadFile(nameFile: string) {
		return this.manFileService.DownloadFile(nameFile);
	}

	UploadFile(id: number) {
		return this.manFileService.UploadFile(id);
	}

	updateFile(file: ManFile) {
		return this.manFileService.updateFile(file);
	}

	createFile(file: ManFile) {
		return this.manFileService.createFile(file);
	}

	getTypeFile() {
		return this.manFileService.getTypeFile();
	}

	getProcessFile(id: number) {
		return this.manFileService.getProcessFile(id);
	}
	/**************************************Export Data *********************************************************/

	exportExcel(fileName: string, data: object) {
		return this.exportDataService.exportExcel(fileName, data);
	}

	exportCSV(fileName: string, data: object) {
		return this.exportDataService.exportCSV(fileName, data);
	}

	exportFile(typeFile: number, fileName: string, data: object) {
		return this.exportDataService.exportFile(typeFile, fileName, data);
	}

	/************************************** Title *************************************************************/

	getTitles(
		title: Title,
		getPayments: boolean,
		currentPage: number,
		sizePage: number
	) {
		return this.titleService.getTitles(
			title,
			getPayments,
			currentPage,
			sizePage
		);
	}

	putTitle(title: Title) {
		return this.titleService.putTitle(title);
	}

	getSettledTitles(
		dealerCode: string,
		dataInicio: string,
		dataFim: string,
		dealerMatrizCode: string
	) {
		return this.titleService.getSettledTitles(
			dealerCode,
			dataInicio,
			dataFim,
			dealerMatrizCode
		);
	}

	getOverdueTitles(dealerCode: string, dealerMatrixCode: string) {
		return this.titleService.getOverdueTitles(dealerCode, dealerMatrixCode);
	}

	getStatusTitle() {
		return this.titleService.getStatusTitle();
	}

	getContributionStatusTitle() {
		return this.titleService.getContributionStatusTitle();
	}

	buildFile(typeFile: string, product: string) {
		return this.titleService.buildFile(typeFile, product);
	}

	resendTitle(titleList: Title[]) {
		return this.titleService.resendTitle(titleList);
	}

	getTitlesReport(title: Title) {
		return this.titleService.getTitlesReport(title);
	}

	/************************************** Account *************************************************************/

	getAccount() {
		return this.accountService.getAccount();
	}

	/************************************** Aps *************************************************************/

	getRoleUser() {
		return this.parameterService.getRoleUser();
	}

	getApsRole() {
		return this.parameterService.getApsRole();
	}


	/************************************** TLK *************************************************************/

	getAllPlans(filters: any) {
		return this.tlkService.getAllPlans(filters);
	}

	uploadPlans(plans: any) {
		return this.tlkService.uploadPlans(plans);
	}

	getPlanById(planId: string) {
		return this.tlkService.getPlanById(planId);
	}

	getTaxById(planId: string) {
		return this.tlkService.getTaxById(planId)
	}

	getViewPackages() {
		return this.tlkService.getViewPackages();
	}

	approvePlan(planId: string) {
		return this.tlkService.approvePlan(planId);
	}

	disapprovePlan(planId: string) {
		return this.tlkService.disapprovePlan(planId);
	}

	updatePlan(planId: string, plan: any) {
		return this.tlkService.updatePlan(planId, plan);
	}

	updateTax(taxId: string, tax: any) {
		return this.tlkService.updateTax(taxId, tax);
	}

	createPackages(packages: any) {
		return this.tlkService.createPackages(packages);
	}

	getPackages() {
		return this.tlkService.getPackages();
	}

	deletePackages(idPackage: string) {
		return this.tlkService.deletePackages(idPackage);
	}

	updateTableBradesco(tableBrad: any) {
		return this.tlkService.updateTableBrad(tableBrad);
	}

	/************************************** Dashboard *************************************************************/

	getDashboard(day: string, country: string = 'BRA') {
		return this.dashboardService.getDashboard(day, country);
	}

} //end class
